import React, { useEffect, useState } from "react";
import { StudentIDFormat } from "../../../../Library/GlobalHelper";
import LoadingBtn from "../../../Widgets/LoadingBtn";
import { Request2Estes } from "../../../../Templates/components/APIs";

export default function AcadInfo({ studentStatus }) {
  let enrollment = "";
  if (studentStatus.enrollment_type_id) {
    let enrollmentType = studentStatus.enrollment_type_id.split(".");
    enrollment = enrollmentType[enrollmentType.length - 1];
  }
  const currentSemester = studentStatus.semester_status.find(
    (item) => item.atp_term.id === studentStatus.atp_term.id
  );

  const [cpdp, setCpdp] = useState({ loading: false, data: 0, message: "" });
  const GET_CPDP_POINT = async (param) => {
    setCpdp({ loading: true, data: 0, message: "" });
    const payload = {
      parameters: param,
      target_data: "GET_CPDP_POINT",
    };
    const result = await Request2Estes(payload);
    if (result.data && Object.values(result.data).length > 0) {
      const get_current_user =
        result.data.dt &&
        result.data.dt.find(
          (item) => item.studentid === studentStatus?.studentid
        );
      setCpdp({
        loading: false,
        data: get_current_user ? get_current_user?.points : "",
        message: "",
      });
    } else {
      setCpdp({ loading: false, data: 0, message: result.message });
    }
  };

  useEffect(() => {
    if (studentStatus?.studentid) {
      GET_CPDP_POINT({ studentid: studentStatus?.studentid.toString() || "" });
    }
  }, [studentStatus]);

  return (
    <div className="card card-custom gutter-b">
      <div className="card-body">
        <h3 className="mb-8">Academic Overview</h3>
        <div className="w-100">
          <div className="d-flex mb-3 justify-content-between align-items-center">
            <div className="font-weight-bolder">Student ID</div>
            <div className="text-capitalize">
              {studentStatus.studentid &&
                StudentIDFormat(studentStatus.studentid)}
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Cummulative Earned Credits</div>
            <div className="text-capitalize">
              {studentStatus.ccredit_pass ? studentStatus.ccredit_pass : 0} SKS
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Cummulative GPA</div>
            <div className="text-capitalize">
              {studentStatus.cgpa ? studentStatus.cgpa : 0} (
              {studentStatus.avg_grade ? studentStatus.avg_grade : "-"})
            </div>
          </div>

          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Current Semester</div>
            <div className="text-capitalize">
              {currentSemester
                ? currentSemester.semester
                : studentStatus.semester}
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Current Semester Credit</div>
            <div className="text-capitalize">
              {currentSemester ? currentSemester.credit_all : 0} SKS
            </div>
          </div>

          {cpdp.loading ? (
            <LoadingBtn />
          ) : cpdp.data ? (
            <div
              className={`d-flex justify-content-between mb-3 align-items-center ${
                cpdp.data < 100 ? "bg-danger px-2 rounded text-white" : ""
              }`}
            >
              <div className="font-weight-bolder">CPDP Point</div>
              <div>
                <span className="mr-2">
                  {cpdp.data}
                  {cpdp.data < 100 ? "/100" : ""}
                </span>
                <span className="text-uppercase font-weight-bolder">
                  · {cpdp.data >= 100 ? "completed" : "incomplete"}
                </span>
              </div>
            </div>
          ) : ""}
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Status</div>
            <div className="text-capitalize">
              {studentStatus.status
                ? studentStatus.status.name
                  ? studentStatus.status.name
                  : "-"
                : "-"}
            </div>
          </div>
          {studentStatus.corporate ? (
            <div className="d-flex justify-content-between mb-3 align-items-center">
              <div className="font-weight-bolder">Corporate</div>
              <div className="text-capitalize">
                {studentStatus.corporate.name
                  ? studentStatus.corporate.name
                  : "-"}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Term Intake</div>
            <div className="text-capitalize">
              {studentStatus.term_intake ? studentStatus.term_intake.name : "-"}
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Enrollment Type</div>
            <div className="text-capitalize">{enrollment}</div>
          </div>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="font-weight-bolder">Department</div>
            <div className="text-capitalize">
              {studentStatus.clu_spec
                ? studentStatus?.clu_spec?.name || "-"
                : "-"}
            </div>
          </div>
          {studentStatus.yudisium_date ? (
            <div className="d-flex justify-content-between mb-3 align-items-center">
              <div className="font-weight-bolder">Yudisium Date</div>
              <div className="text-capitalize">
                {studentStatus.yudisium_date}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
